/********************************************
 * Feature flags (single source of truth)
 ********************************************/
// Attentive: true = gate (block early) + delay; false = do not gate (allow immediate)
window.GATE_ATTENTIVE = (typeof window.GATE_ATTENTIVE === 'boolean') ? window.GATE_ATTENTIVE : true;
// Rebuy: gate unsolicited loads; our own intent-driven load bypasses via data-gate-allow="1"
window.GATE_REBUY     = (typeof window.GATE_REBUY === 'boolean') ? window.GATE_REBUY : true;
// Gorgias (controls both Gorgias + 5gtb)
window.ENABLE_GORGIAS = (typeof window.ENABLE_GORGIAS === 'boolean') ? window.ENABLE_GORGIAS : true;
// Gorgias on PDPs. OFF because the chat bubble overlays the sticky
// add-to-cart bar. Turning this ON both loads chat on product pages AND
// lifts the bubble clear of the sticky bar (body.gorgias-on-pdp rules in
// custom.css) — no template edits needed. Replaces the old "Hide Gorgias
// Chat" CSS blocks that lived in each templates/product*.json.
window.ENABLE_GORGIAS_PDP = (typeof window.ENABLE_GORGIAS_PDP === 'boolean') ? window.ENABLE_GORGIAS_PDP : false;
// Sticky Add-to-Cart Toggle
window.ENABLE_STICKY_ATC = (typeof window.ENABLE_STICKY_ATC === 'boolean') ? window.ENABLE_STICKY_ATC : true;
// TBT batch 2 (2026-08-06): defer the Okendo loyalty bubble + Klaviyo onsite
// forms out of the startup window (each ~0.9s phone-CPU main-thread). Loaded
// on first interaction or 4s idle. The rewards page (loyalty IS the page)
// loads loyalty immediately.
window.GATE_OKENDO_LOYALTY = (typeof window.GATE_OKENDO_LOYALTY === 'boolean') ? window.GATE_OKENDO_LOYALTY
  : !location.pathname.includes('/pages/welcome-to-the-a-list');
window.GATE_KLAVIYO = (typeof window.GATE_KLAVIYO === 'boolean') ? window.GATE_KLAVIYO : true;
// Okendo REVIEWS bundle gate (2026-08-10, PDP TBT sprint): ~2.3s of phone-CPU
// scripting across three chained bundles. PRODUCT PAGES ONLY — the flag is set
// by custom-preload.liquid under a request.page_type == 'product' conditional
// (default false here), because collection pages render their grid stars from
// this same JS. Safe on PDPs: the hero star badge + review JSON-LD are
// server-rendered (Okendo app blocks print the StarRatingSnippet metafield),
// so pre-interaction the page already shows stars; only the below-fold widget
// hydration waits — and reaching it requires scrolling, which releases the gate.
window.GATE_OKENDO_REVIEWS = (typeof window.GATE_OKENDO_REVIEWS === 'boolean') ? window.GATE_OKENDO_REVIEWS : false;
// Google Ads (AW-) gtag + the GTM-loaded duplicate GA4 copy (2026-08-11):
// Elevar's config pushes gtag config commands for AW-973824568 and (again)
// G-JDX9T87WYX onto the shared dataLayer; gtm.js answers by appendChild-ing
// their gtag/js loaders (155KB + 181KB, ~1s+ of collection-page main thread).
// Ads are RESUMING SOON (Ara, 2026-08-11) so the destination stays enabled in
// Elevar — but the client-side load waits for first interaction: conversions
// are unaffected (server-side + purchases require interaction), remarketing
// still tags every engaged visitor, and queued dataLayer commands replay when
// the script lands. Only the &cx=c GA4 duplicate is gated — Elevar's DIRECT
// G- load (no cx param) stays eager so analytics never misses a bounce.
// Known trade: an ad-click visitor who bounces with ZERO interaction stores
// no click cookie → a later return visit loses attribution to that click.
window.GATE_ADS_GTAG = (typeof window.GATE_ADS_GTAG === 'boolean') ? window.GATE_ADS_GTAG : true;
// Meta pixel (2026-08-11, Ara OK): fbevents.js (~104KB + signals/config chain)
// loads via GTM appendChild — same gate mechanics as the Ads gtag. The fbq
// stub queues events pre-load; the chain replays them on first interaction.
// Same accepted trade as AW: zero-interaction bounces excluded from FB
// audiences; conversions unaffected (conversion events follow interaction,
// and Elevar covers server-side regardless).
window.GATE_META_PIXEL = (typeof window.GATE_META_PIXEL === 'boolean') ? window.GATE_META_PIXEL : true;
// Bing UET's auto-injected Clarity copy (clarity.ms/tag/uet/<id>). Our real
// Clarity records via the Shopify customer-events pixel; this second copy is
// disabled in Microsoft Advertising ("Insights"/Clarity unchecked) but their
// tag config keeps serving it (known bug), and bat.js whitelists config keys
// so the deBlock flag can't be passed from GTM. Blocking the script here does
// not touch UET conversion beacons (bat.bing.com/action/*).
window.GATE_UET_CLARITY = (typeof window.GATE_UET_CLARITY === 'boolean') ? window.GATE_UET_CLARITY : true;

/********************************************
 * 0) Third-party GATE: intercept, block, delay
 *    (Attentive + stray Rebuy)
 *  - If GATE_ATTENTIVE === true  → block early Attentive and schedule one delayed load
 *  - If GATE_ATTENTIVE === false → no gating (Shopify/apps may load it immediately)
 *  - Rebuy is always gated except our own intent-driven load (marked gateAllow)
 ********************************************/
(function(){
  const gates = [
    { key:'attentive',   enabled: ()=>window.GATE_ATTENTIVE,   patterns: [/cdn\.attn\.tv\/tag\//i, /cdn\.attn\.tv\/.*dtag/i] },
    // global[.-]: Rebuy's app embed switched from global.js to HASHED bundles
    // (global-<hash>.js) that slipped past the old exact pattern — the gate
    // was silently bypassed and Rebuy ran ~1s of JS at load on every page
    // (found in the 2026-08-06 TBT audit). Our own intent-driven loader still
    // requests plain global.js with data-gate-allow, so it passes.
    { key:'rebuy',       enabled: ()=>window.GATE_REBUY,       patterns: [/cdn\.rebuyengine\.com\/onsite\/js\/(global[.-]|rebuy\.js)/i, /cached\.rebuyengine\.com/i] },
    { key:'uetClarity',  enabled: ()=>window.GATE_UET_CLARITY, patterns: [/clarity\.ms\/tag\/uet\//i] },
    // TBT batch 2 (2026-08-06): the loyalty bubble and Klaviyo's onsite
    // forms bundle both executed inside the startup window (~0.9s each of
    // main-thread on phone-class CPUs) for features nobody uses in second
    // one. Blocked at load; replayed on first interaction / 4s idle by the
    // deferred loader below (exact blocked URLs recorded in __gateBlocked —
    // both vendors version their bundle filenames). Reviews stars stay
    // eager (visible content). The rewards page skips the loyalty gate.
    { key:'okeLoyalty',  enabled: ()=>window.GATE_OKENDO_LOYALTY, patterns: [/cdn-static\.okendo\.io\/loyalty\/js\//i] },
    { key:'klaviyo',     enabled: ()=>window.GATE_KLAVIYO,     patterns: [/static\.klaviyo\.com\/onsite\/js\/(FMnWN4\/)?klaviyo\.js/i] },
    // okendo-reviews.js is the entry loader — blocking it stops the whole
    // core/init/widget chain. PDP-only via the preload-snippet flag.
    { key:'okeReviews',  enabled: ()=>window.GATE_OKENDO_REVIEWS, patterns: [/cdn-static\.okendo\.io\/reviews-widget-plus\/js\/okendo-reviews\.js/i] },
    // Two separate keys (NOT one with two patterns): __gateBlocked stores one
    // URL per key, and both scripts must replay. AW- matches any Ads id
    // (future-proof); the G- pattern requires &cx=c so the bare Elevar-loaded
    // GA4 copy (no cx param) stays eager.
    { key:'awGtag',      enabled: ()=>window.GATE_ADS_GTAG, patterns: [/googletagmanager\.com\/gtag\/js\?id=AW-/i] },
    { key:'gaDupeGtag',  enabled: ()=>window.GATE_ADS_GTAG, patterns: [/googletagmanager\.com\/gtag\/js\?id=G-[A-Z0-9]+&cx=c/i] },
    { key:'metaPixel',   enabled: ()=>window.GATE_META_PIXEL, patterns: [/connect\.facebook\.net\/[^/]+\/fbevents\.js/i] }
  ];
  window.__gateBlocked = window.__gateBlocked || {};
  const matchGate = (src) => gates.find(g => g.enabled() && g.patterns.some(p => p.test(src)));

  const origAppend = Node.prototype.appendChild;
  const origInsert = Node.prototype.insertBefore;

  function interceptAdd(fn) {
    return function(child, ref) {
      try {
        if (child && child.tagName === 'SCRIPT') {
          const src = child.src || '';
          // Allow our explicitly permitted scripts
          if (child.dataset?.gateAllow === '1') return fn.apply(this, arguments);
          // Block if a gate is active for this src (record the exact URL so
          // the deferred loader can replay versioned bundle filenames)
          if (src) { const g = matchGate(src); if (g) { window.__gateBlocked[g.key] = src; return child; } }
        }
      } catch(_) {}
      return fn.apply(this, arguments);
    };
  }
  Node.prototype.appendChild  = interceptAdd(origAppend);
  Node.prototype.insertBefore = interceptAdd(origInsert);

  // Observer fallback (2026-08-11): Elevar's embed runs BEFORE this file and
  // captures pristine appendChild/insertBefore references — prototype patching
  // never sees its inserts (found when the Meta pixel sailed through the
  // gate). A MutationObserver fires after insertion but before execution
  // (observer microtasks precede script run), so neutralize matching nodes
  // the yett way regardless of who inserted them or how. Records into
  // __gateBlocked for the standard interaction replay. Disconnects once all
  // gates have released (30s ceiling as backstop).
  (function(){
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n || n.nodeType !== 1 || n.tagName !== 'SCRIPT' || !n.src) continue;
          if (n.dataset && n.dataset.gateAllow === '1') continue;
          var g = matchGate(n.src);
          if (g) {
            window.__gateBlocked[g.key] = n.src;
            n.type = 'javascript/blocked';
            if (n.parentNode) n.parentNode.removeChild(n);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    window.__emGateObserverReady = true; // hand-off signal: custom-preload's parser blocker may disconnect
    var stop = setInterval(function(){
      var anyOn = gates.some(function (g) { try { return g.enabled(); } catch(_) { return false; } });
      if (!anyOn) { clearInterval(stop); try { mo.disconnect(); } catch(_) {} }
    }, 2000);
    setTimeout(function(){ clearInterval(stop); try { mo.disconnect(); } catch(_) {} }, 30000);
  })();

  /* Klaviyo font-shadowing defuse (CLS fix, 2026-08-05)
     Klaviyo's onsite JS injects <style id="kl-custom-fonts"> declaring Poppins
     100–900 from fonts.gstatic (its form-branding fonts). Declared after the
     theme's inline @font-face, those faces SHADOW our preloaded self-hosted
     Poppins 400/600 for the whole page: body text double-downloads and
     re-renders when the Google copy lands late (PSI recorded every layout
     shift on the OneTrust banner from exactly these swaps; mobile CLS 0.104).
     Renaming the family inside Klaviyo's block keeps their faces valid for
     their own form CSS but stops the sitewide hijack. Root fix is removing
     Google fonts from Klaviyo's form branding (admin); this guards either way
     and no-ops if the block is absent or Poppins-free. */
  function defuseKlFonts(el){
    try {
      if (!el || el.dataset.emDefused) return;
      el.dataset.emDefused = '1';
      if (/Poppins/i.test(el.textContent)) {
        el.textContent = el.textContent.replace(/(['"]?)Poppins\1/gi, "'Poppins KL'");
      }
    } catch(_) {}
  }
  defuseKlFonts(document.getElementById('kl-custom-fonts'));
  const klMo = new MutationObserver(function(muts){
    for (const m of muts) for (const n of m.addedNodes) {
      if (n.nodeType === 1 && n.tagName === 'STYLE' && n.id === 'kl-custom-fonts') {
        defuseKlFonts(n); klMo.disconnect(); return;
      }
    }
  });
  klMo.observe(document.documentElement, { childList: true, subtree: true });

  // Local helpers (scoped here so gate can run before global helpers exist)
  function preconnect(href, key){
    if (document.querySelector(`link[data-preconnect="${key}"]`)) return;
    const l=document.createElement('link');
    l.rel='preconnect'; l.href=href; l.crossOrigin='anonymous'; l.dataset.preconnect=key;
    document.head.appendChild(l);
  }
  function loadOnce(src, key, presenceSubstring, attrs) {
    if (presenceSubstring && document.querySelector(`script[src*="${presenceSubstring}"]`)) return Promise.resolve();
    if (key && document.querySelector(`script[data-key="${key}"]`)) return Promise.resolve();
    return new Promise(res => {
      const s=document.createElement('script');
      s.src=src; s.defer=s.async=true;
      if (key) s.dataset.key=key;
      if (attrs && typeof attrs==='object') for (const [k,v] of Object.entries(attrs)) try { s.setAttribute(k, v); } catch {}
      s.onload=res; document.head.appendChild(s);
    });
  }
  const runIdleLocal = (cb, timeout=500) => {
    if ('requestIdleCallback' in window) { try { return requestIdleCallback(cb, { timeout }); } catch(_){} }
    return setTimeout(cb, timeout);
  };

  // Public openers (used by our delayed loaders or manual testing)
  window.__openAttentiveGate = function(){
    window.GATE_ATTENTIVE = false; // drop the gate so future pixel injections pass
    if ([...document.scripts].some(s => (s.src||'').includes('cdn.attn.tv/tag/'))) return;
    preconnect('https://cdn.attn.tv','attn-pre');
    const s=document.createElement('script');
    s.src='https://cdn.attn.tv/tag/4-latest/unified-tag.js';
    s.async=s.defer=true; s.dataset.key='attentive'; s.dataset.gateAllow='1';
    document.head.appendChild(s);
  };
  window.__openRebuyGate = function(){
    window.GATE_REBUY = false;
    // rebuy.js is Rebuy's current LOADER (global.js now just 302s to a hashed
    // bundle that doesn't self-boot); the loader injects the real bundle —
    // which passes the gate because GATE_REBUY is already false here.
    if (window.Rebuy || document.querySelector('script[src*="cdn.rebuyengine.com/onsite/js/rebuy.js"]')) return;
    preconnect('https://cdn.rebuyengine.com','rebuy-pre');
    const s=document.createElement('script');
    s.src='https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=' + (window.Shopify && Shopify.shop ? Shopify.shop : 'ella-mila-inc.myshopify.com');
    s.async=s.defer=true; s.dataset.key='rebuy-global'; s.dataset.gateAllow='1';
    document.head.appendChild(s);
  };

  // SHARED scroll-quiet scheduler (2026-08-11): run fn only once scrolling
  // has settled — no scroll events for 600ms (12s ceiling for pathological
  // never-quiet sessions). Why: the first interaction is often a FLICK, and
  // everything that used to fire ON that interaction (vendor replays,
  // Gorgias, Attentive) parsed+executed mid-momentum — on a REFRESH the
  // bundles come from cache and land even denser. Field repro (Ara, iPhone,
  // 2026-08-11): fresh load + accept-banner THEN flick = smooth (the accept
  // tap absorbed the burst); refresh + flick-first = scroll starts then
  // stops. Non-scroll interactions pass after one 600ms beat; the work
  // still happens within ~1s of the interaction, just never mid-scroll.
  (function(){
    let lastScroll = 0;
    addEventListener('scroll', () => { lastScroll = performance.now(); }, { passive: true, capture: true });
    window.__emScrollQuiet = function(fn){
      const QUIET = 600, CEIL = 12000, t0 = performance.now();
      const check = () => {
        const now = performance.now();
        const quiet = lastScroll === 0 ? (now - t0 >= QUIET) : (now - lastScroll >= QUIET);
        if (quiet || now - t0 >= CEIL) { fn(); return; }
        setTimeout(check, Math.max(150, QUIET - (now - Math.max(lastScroll, t0))));
      };
      setTimeout(check, QUIET);
    };
  })();

  // Deferred release for the TBT-batch-2 gates (Okendo loyalty + Klaviyo):
  // first interaction OR 4s idle, whichever comes first. Replays the exact
  // blocked bundle URLs (vendors version their filenames); fallback URLs
  // cover the page-loaded-so-fast-nothing-was-blocked-yet case (the embed's
  // inject may come later — the gate flag going false lets it pass then).
  (function(){
    let released = false;
    // Okendo badge hydration flash-mask (2026-08-10): the reviews JS REPLACES
    // the server-rendered .oke-sr node when it boots (verified: the original
    // node disconnects; new markup differs ~100 bytes). During page load that
    // swap hid in the noise; post-gate it lands on a settled page and reads
    // as a flash. Pin an exact-pixels overlay (clone + opaque ancestor bg)
    // over each badge for the swap; lift it when mutations go quiet.
    // Space adjustments are only allowed OFF-SCREEN (2026-08-10 final round):
    // the previous animated collapse WAS the residual bounce Ara saw — easing
    // 30-40px of surplus above the widget header slid the very content they
    // were watching. Policy now: under-reservation grows once at the bottom
    // edge (usually below the viewport); surplus is held (30px of extra
    // whitespace inside a 2k px section is invisible) and snapped away only
    // when the block leaves the viewport or the tab hides.
    function whenOffscreen(el, fn){
      try {
        if (!('IntersectionObserver' in window)) { fn(); return; }
        var done = false, io;
        var run = function(){ if (done) return; done = true; try { io.disconnect(); } catch(_) {} fn(); };
        io = new IntersectionObserver(function(entries){
          for (var i = 0; i < entries.length; i++) if (!entries[i].isIntersecting) { run(); return; }
        });
        io.observe(el);
        addEventListener('pagehide', run, { once: true });
        document.addEventListener('visibilitychange', function(){ if (document.hidden) run(); });
        // a click inside = engagement (load-more, filters): release now so
        // expanding content is never clipped — that growth is user-expected
        el.addEventListener('click', run, true);
      } catch(_) { fn(); }
    }
    // Badge FREEZE (2026-08-10, endgame): the server-rendered badge is
    // correct — the only thing hydration adds is clickability, and its
    // re-render (vendor version skew 0.101.5→0.102.0) is what kept
    // shifting 1-3px. Remove the data-oke-star-rating marker so Okendo's
    // hydrator skips the badge entirely (zero re-render = zero shift, by
    // construction) and provide the click/keyboard scroll-to-reviews
    // behavior ourselves, matching v0.102.0's a11y semantics.
    function freezeOkeBadges(){
      try {
        document.querySelectorAll('[data-oke-star-rating]').forEach(function(mount){
          var sr = mount.querySelector('.oke-sr');
          if (!sr || mount.__emFrozen) return;
          mount.__emFrozen = true;
          mount.removeAttribute('data-oke-star-rating');
          var inner = sr.firstElementChild || sr;
          inner.setAttribute('tabindex', '0');
          inner.setAttribute('role', 'button');
          inner.setAttribute('aria-label', 'Rated ' + ((sr.textContent.match(/\d\.\d/) || [''])[0]) + ' out of 5 stars — read reviews');
          inner.style.cursor = 'pointer';
          var go = function(e){
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            var w = document.querySelector('[id*="okendo_reviews_widget"]');
            if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
          };
          inner.addEventListener('click', go);
          inner.addEventListener('keydown', go);
        });
      } catch(_) {}
    }
    function maskOkeBadges(){
      try {
        document.querySelectorAll('.oke-sr').forEach(function(el){
          // Clamp the theme-owned app-block wrapper, NOT el.parentNode:
          // Okendo sometimes replaces its whole anonymous wrapper div during
          // hydration — a clamp on that node leaves the DOM with it and the
          // block collapses 26→0→26 anyway (the intermittent dip, traced
          // 2026-08-10). The shopify-block div survives every swap.
          var parent = (el.closest && el.closest('.shopify-block')) || el.parentNode;
          if (!parent || el.__emMasked) return;
          var r = el.getBoundingClientRect(); if (!r.width || !r.height) return; // not renderable yet — armer retries; flag only on success
          var docTop = r.top + window.scrollY, docLeft = r.left + window.scrollX;
          el.__emMasked = true;
          // Layout latch: the node-swap DETACHES the old badge before the new
          // one lands — the container collapses ~26px for a few frames and the
          // whole page below bounces (66px dip measured per-frame, 2026-08-10).
          // The pixel overlay can't stop layout; pinning the container height
          // through the swap does.
          // FIXED height + clip (not min-height): Okendo inserts the NEW badge
          // before removing the old — the block briefly holds both (~2×) and
          // min-height can't stop growth. Ara-observed "down then back up"
          // (2026-08-10). Clipping hides the transient double-render; the
          // overlay shows the stable clone meanwhile.
          parent.__emPrevH = parent.style.height;
          parent.__emPrevOv = parent.style.overflow;
          parent.style.height = parent.getBoundingClientRect().height + 'px';
          parent.style.overflow = 'hidden';
          var bg = 'rgb(255,255,255)', a = parent;
          while (a && a !== document.documentElement) {
            var c = getComputedStyle(a).backgroundColor;
            if (c && c !== 'transparent' && !/rgba\([^)]*,\s*0\s*\)/.test(c)) { bg = c; break; }
            a = a.parentNode;
          }
          var ov = document.createElement('div');
          ov.setAttribute('aria-hidden', 'true');
          ov.style.cssText = 'position:absolute;z-index:10;pointer-events:none;overflow:hidden;'
            + 'top:' + (r.top + window.scrollY) + 'px;left:' + (r.left + window.scrollX) + 'px;'
            + 'width:' + r.width + 'px;height:' + r.height + 'px;background:' + bg + ';';
          var clone = el.cloneNode(true);
          Array.prototype.slice.call(clone.querySelectorAll('script')).forEach(function(s){ s.parentNode.removeChild(s); });
          clone.style.margin = '0';
          ov.appendChild(clone);
          document.body.appendChild(ov);
          // Guardian semantics (2026-08-10, same fix as the section latch):
          // Gecko hydrates seconds after release — a short no-mutation bail
          // let the overlay+latch expire BEFORE the swap, resurrecting the
          // dip/flash. The overlay is an exact clone with pointer-events:none
          // (clicks pass through), so holding it long is harmless.
          var settle = null, swapped = false, done = false;
          function finish(){
            if (done) return; done = true;
            try { mo.disconnect(); } catch(_) {}
            if (settle) clearTimeout(settle);
            // Align-at-reveal (2026-08-10): the hydrated badge lands a few px
            // off the server badge's spot inside the clamped block — the
            // overlay lift exposed that as a small down-up nudge (Ara). While
            // the overlay still covers, measure the offset and counter it
            // with a layout-neutral transform, THEN reveal: pixel-aligned.
            try {
              var nb = parent.querySelector('.oke-sr');
              if (nb) {
                var nr = nb.getBoundingClientRect();
                var dy = (nr.top + window.scrollY) - docTop;
                var dx = (nr.left + window.scrollX) - docLeft;
                if ((dy || dx) && Math.abs(dy) <= 10 && Math.abs(dx) <= 10) {
                  nb.style.transform = 'translate(' + (-dx) + 'px,' + (-dy) + 'px)';
                }
              }
            } catch(_) {}
            if (ov.parentNode) ov.parentNode.removeChild(ov);
            // new badge can be a few px shorter than the clamp — restoring
            // on-screen shifts the content the user is reading; defer it
            whenOffscreen(parent, function(){
              parent.style.height = parent.__emPrevH || '';
              parent.style.overflow = parent.__emPrevOv || '';
            });
          }
          var mo = new MutationObserver(function(){
            swapped = true;
            if (settle) clearTimeout(settle);
            settle = setTimeout(finish, 1200); // quiet after a real swap = done (covers Okendo's late attribute pass)
          });
          mo.observe(parent, { childList:true, subtree:true, attributes:true, characterData:true });
          setTimeout(function(){ if (!swapped) finish(); }, 15000); // never swapped (JS failed) → unmask
          setTimeout(finish, 20000);                                // hard ceiling
        });
      } catch(_) {}
    }
    // Okendo widget growth-jump absorber (2026-08-10): post-gate, the reviews
    // widget block hydrates 0 → ~1.7k px desktop / ~3.1k px mobile in ~4 visible
    // steps, bouncing everything below it (+ scroll-anchoring corrections =
    // perceived up/down). Reserve an estimated min-height the moment the gate
    // releases — calibrated on in-a-rush: desktop 1714px = 450 + 5×255, mobile
    // 3084px = 580 + 5×500, rows = min(reviewCount, 5) parsed from the
    // server-rendered badge — then ease away any leftover once hydration
    // settles (animated min-height collapse, no snap). Products with zero
    // reviews have no badge → no reservation (their widget renders short).
    function reserveOkeSpace(){
      try {
        var badge = document.querySelector('.oke-sr');
        if (!badge) return;
        var m = (badge.textContent || '').match(/(\d[\d,]*)\s+Review/i);
        var count = m ? parseInt(m[1].replace(/,/g, ''), 10) : 0;
        if (!count) return;
        var rows = Math.min(count, 5);
        var mobile = window.innerWidth < 769;
        // Estimates are deliberately GENEROUS (+~15%): under the offscreen-
        // only release policy surplus space is visually free (static
        // whitespace, snapped away off-screen), while under-reservation
        // forces an on-screen growth step above watched content — the last
        // visible artifact (chromium +40, 2026-08-10). Measured naturals on
        // in-a-rush: widget 1714/3084, carousel 388/436, keywords 70.
        var kw = document.querySelector('[id*="okendo_reviews_keywords"]');
        var plan = [
          { el: document.querySelector('[id*="okendo_reviews_widget"]'),   est: mobile ? 660 + rows * 500 : 510 + rows * 255 },
          { el: document.querySelector('[id*="okendo_reviews_carousel"]'), est: mobile ? 510 : 450 },
          { el: kw, est: kw ? kw.getBoundingClientRect().height + 14 : 0 }
        ];
        // Guardian latch (rewritten 2026-08-10 after the Firefox trace): a
        // quiet-timer alone released the space BEFORE Okendo's real teardown
        // (Gecko hydrates late — the section visibly collapsed 1984→127px and
        // rebuilt over ~2s). Now: hold while content is below 80% of the max
        // seen (mid-rebuild), re-latch pre-paint if a teardown strikes after
        // release (MutationObserver runs before rendering), give up only at a
        // 15s ceiling. Over-reservation still animates away (transitioning
        // min-height est→0 is a no-op — rendered height = max(content, min)
        // crosses content within ms; animate explicit height instead — and
        // scrollHeight lies under a forced min, so drop/measure/restore
        // within one task, no paint between).
        // FIXED-height clamp + clip, not min-height (2026-08-10, after Ara
        // observed "down then back up"): Okendo transiently double-renders
        // (new content inserted before old removed), so a floor can't stop
        // the growth spike — a clamp with overflow:hidden makes both the
        // teardown AND the spike invisible. Guardian semantics retained:
        // hold while natural content < 80% of max seen (mid-rebuild),
        // re-clamp pre-paint on post-release teardown, 15s ceiling.
        function latch(el, clampH){
          if (!el || el.__emReserved || !clampH) return;
          el.__emReserved = true;
          var maxSeen = clampH, settle = null, holding = true, ceiling = false, snapQueued = false;
          var prevH = el.style.height, prevOv = el.style.overflow;
          function clamp(h){ el.style.height = h + 'px'; el.style.overflow = 'hidden'; }
          function natural(){
            var hadH = el.style.height; el.style.height = '';
            var n = el.getBoundingClientRect().height; el.style.height = hadH; return n;
          }
          clamp(clampH);
          function snap(){
            holding = false;
            el.style.height = prevH || '';
            el.style.overflow = prevOv || '';
          }
          function attempt(){
            if (!holding || snapQueued) return;
            var n = natural();
            if (n > maxSeen) maxSeen = n;
            if (!ceiling && n < maxSeen * 0.8) { arm(1200); return; } // mid-teardown/rebuild — keep holding
            var cur = el.getBoundingClientRect().height;
            if (n > cur + 1) { clamp(n); maxSeen = n; arm(1200); return; } // under-reserved: grow once at the bottom edge
            // surplus (or exact): release only once the block is off-screen
            snapQueued = true;
            whenOffscreen(el, snap);
          }
          function arm(ms){ if (settle) clearTimeout(settle); settle = setTimeout(attempt, ms); }
          var mo = new MutationObserver(function(){
            if (!holding) {
              // teardown after release: re-clamp BEFORE this frame paints
              if (el.getBoundingClientRect().height < maxSeen * 0.8) {
                holding = true; snapQueued = false;
                clamp(maxSeen);
              } else return;
            }
            if (!snapQueued) arm(1200);
          });
          mo.observe(el, { childList: true, subtree: true });
          // clicks inside a still-clamped block (load-more, filters) must
          // never be answered with clipped content — release on the spot
          el.addEventListener('click', function(){
            if (holding) { try { mo.disconnect(); } catch(_) {} snap(); }
          }, true);
          arm(3000); // nothing ever mutates (script failed) → release the space
          setTimeout(function(){ ceiling = true; try { mo.disconnect(); } catch(_) {} if (holding) attempt(); }, 15000);
        }
        plan.forEach(function(p){
          if (!p.el) return;
          // Okendo sometimes server-renders the full widget HTML (block
          // already ~1.7k px tall) and sometimes ships it empty for JS to
          // build. If real content exists, latch ITS height (hydration
          // replaces in place at ~equal size → zero movement); only fall
          // back to the estimate when the block starts empty.
          var base = p.el.getBoundingClientRect().height;
          latch(p.el, base > 40 ? base : p.est);
        });
        // Blanket latch on the whole apps SECTION (+32px buffer): absorbs the
        // inter-block composition drift the per-block latches can't see —
        // measured +20px of margin materialization between blocks + keyword
        // growth. Read AFTER the block latches so the reservation heights are
        // included; leftover buffer animates away at settle via latch()'s
        // finish. Firefox especially: its scroll anchoring is less forgiving
        // than Chrome's, so even small below-fold steps read as bounce.
        var widEl = plan[0].el;
        var sec = widEl && widEl.closest && widEl.closest('.shopify-section');
        if (sec) latch(sec, sec.getBoundingClientRect().height + 90);
      } catch(_) {}
    }
    // Real users interact DURING page load (the gate releases in ~150ms on a
    // fast mouse move) — at that moment the badge may not be parsed or sized
    // yet, and a single mask/reserve pass silently no-ops, leaving hydration
    // unprotected (THE reproduced cause of the visible down-up bounce,
    // 2026-08-10). Retry every 125ms until the badge is maskable; hydration
    // needs script fetch + exec (~1.5s+), so the armer wins the race.
    function armOkeStabilizers(){
      var tries = 0;
      (function tick(){
        var badge = document.querySelector('.oke-sr');
        if (badge && badge.__emMasked) return; // armed
        if (badge) {
          var r = badge.getBoundingClientRect();
          // freeze makes the overlay/mask obsolete: a never-re-rendered badge
          // needs no cover — and the overlay clone itself sat 1-2px off
          // (body-context line-height), which read as a "shift down" while it
          // covered the frozen badge (Ara, 2026-08-10). maskOkeBadges is
          // retired from this path; kept in the file only as fallback
          // documentation should Okendo ever ignore the marker removal.
          if (r.width && r.height) { freezeOkeBadges(); reserveOkeSpace(); return; }
        }
        if (++tries < 80) setTimeout(tick, 125); // keep trying ~10s
      })();
    }
    function releaseDeferred(e){
      if (e && e.isTrusted === false) return; // synthetic events (e.g. the PDP clickSecondThumb auto-click) are not engagement
      if (released) return; released = true;
      // scroll-quiet: never parse/execute the vendor burst mid-flick — the
      // interaction arms the release, the drain waits for scrolling to settle
      window.__emScrollQuiet(function(){ releaseDeferredNow(); });
    }
    function releaseDeferredNow(){
      // STAGGERED replay (2026-08-11, INP work): inserting all deferred
      // scripts at once piled ~2s of vendor execution into the seconds right
      // after the user's FIRST interaction — interactions 2..N ate that burst
      // as input delay (Clarity field INP: mobile avg 256ms, /search 635ms;
      // event-timing traces showed 400-580ms input delays with ~1ms handler
      // time). Queue instead: first script immediately (content-relevant
      // ones enqueue first — replay call order is the priority order), each
      // subsequent one on an idle slice. Worst case the queue drains in ~3s.
      const replayQueue = [];
      const replay = (key, fallback) => {
        const src = (window.__earlyBlocked && window.__earlyBlocked[key]) || (window.__gateBlocked && window.__gateBlocked[key]) || fallback;
        if (!src) return;
        if (document.querySelector('script[src="' + src + '"][data-gate-allow]')) return;
        replayQueue.push({ key, src });
      };
      const drainReplays = () => {
        const item = replayQueue.shift();
        if (!item) return;
        if (!document.querySelector('script[src="' + item.src + '"][data-gate-allow]')) {
          const s = document.createElement('script');
          s.src = item.src; s.async = true; s.dataset.gateAllow = '1'; s.dataset.key = 'deferred-' + item.key;
          // serialize EXECUTION, not just insertion: onload fires after a
          // classic script runs, so the next vendor never executes while
          // this one still owns the main thread; small idle gap between.
          s.onload = s.onerror = () => { if (replayQueue.length) runIdle(drainReplays, 800); };
          document.head.appendChild(s);
        } else if (replayQueue.length) {
          runIdle(drainReplays, 300); // dedupe skip — keep the chain moving
        }
      };
      // Enqueue order = priority order: visible content first (reviews
      // widget/stars), engagement features next (Klaviyo forms, loyalty
      // bubble), pure marketing tags last — they tolerate the tail of the
      // idle-spaced drain best.
      if (window.GATE_OKENDO_REVIEWS) { window.GATE_OKENDO_REVIEWS = false; armOkeStabilizers(); replay('okeReviews', 'https://cdn-static.okendo.io/reviews-widget-plus/js/okendo-reviews.js'); }
      if (window.GATE_KLAVIYO) { window.GATE_KLAVIYO = false; replay('klaviyo', 'https://static.klaviyo.com/onsite/js/FMnWN4/klaviyo.js?company_id=FMnWN4'); }
      if (window.GATE_OKENDO_LOYALTY) { window.GATE_OKENDO_LOYALTY = false; replay('okeLoyalty', null); }
      // ads: no fallback URLs — if nothing was blocked there is nothing to restore
      if (window.GATE_ADS_GTAG) { window.GATE_ADS_GTAG = false; replay('awGtag', null); replay('gaDupeGtag', null); }
      // meta: fallback URL required — the fbq pre-stub usually PREVENTS the
      // insert entirely, so there may be no blocked URL to replay
      if (window.GATE_META_PIXEL) { window.GATE_META_PIXEL = false; replay('metaPixel', 'https://connect.facebook.net/en_US/fbevents.js'); }
      drainReplays();
    }
    // Interaction-only (no idle timer): a session that never scrolls, moves,
    // or taps has no use for signup forms or a loyalty bubble — and a timer
    // lands inside lab observation windows, negating the TBT win. Same
    // doctrine as the Attentive and Rebuy gates.
    ['wheel','mousemove','touchstart','keydown','click'].forEach(ev =>
      addEventListener(ev, releaseDeferred, {passive:true, capture:true}));
  })();

  // Attentive loads on FIRST INTERACTION only (2026-08-05; previously PDP
  // idle+4s, other pages interaction + 15s fallback). Any timer fallback
  // lands inside Lighthouse's lab window on slow connections and the popup
  // creative registers as LCP (21.5s lab LCP on the PDP audit — the single
  // biggest mobile-score cap). Interaction-only keeps the popup for every
  // engaged visitor — scroll, tap, click, key, or mere mouse movement — and
  // skips only sessions that never touch the page at all, which describes
  // lab runs and bounced tabs, not shoppers. No vendor-side change needed.
  //
  // SCROLL-QUIET DEFERRAL (2026-08-11): the first interaction is often a
  // FLICK — and Attentive's creative opens ~1.3-1.9s after injection with a
  // hard scroll-lock (overflow:hidden + position:absolute on BOTH html and
  // body), which kills iOS momentum scrolling mid-flight (field report:
  // "flick scrolls, glitches, stops"). So: the interaction still arms the
  // gate, but injection waits until scrolling has settled — no scroll events
  // for QUIET_MS. Non-scroll interactions (click, keypress, bare mousemove)
  // pass through after one QUIET_MS beat. CEILING_MS bounds pathological
  // never-quiet sessions (continuous scroll-event storms) so the signup
  // surface still eventually appears; a mid-scroll popup at 12s is the rare
  // worst case, not the common one.
  if (window.GATE_ATTENTIVE === true) {
    let opened=false;
    const tryOpen=(e)=>{
      if(e && e.isTrusted === false) return; if(opened) return; opened=true;
      window.__emAttnQuiet = true; // marker: deferral armed (also CDN-freshness probe)
      window.__emScrollQuiet(window.__openAttentiveGate);
    };
    ['wheel','click','keydown','touchstart','mousemove'].forEach(ev=>addEventListener(ev, tryOpen, {passive:true, capture:true}));
  }
})();

/********************************************
 * OneTrust banner autofocus guard (2026-08-11)
 *
 * otBannerSdk calls banner.focus() when the banner first shows (~2.2s
 * after load, zero interaction — verified via focus-prototype trace,
 * otBannerSdk.js:7:95355). Two field symptoms, one cause:
 *  - iOS: a flick during that window dies abruptly — programmatic focus()
 *    landing mid-momentum halts the scroll ("first flick stops" report;
 *    the jitter half of that report was Attentive's scroll-lock, fixed
 *    separately via the scroll-quiet deferral above).
 *  - /search: the autofocus steals keystrokes from the search input for
 *    fresh visitors (Clarity INP audit — typing goes to the banner).
 *
 * Guard: patch HTMLElement.focus to swallow programmatic focus targeting
 * the BANNER (#onetrust-banner-sdk only — never the preference-center
 * modal, whose focus trap must keep working) unless the user actually
 * interacted with the consent UI in the last 1.5s (e.g. pref-center
 * "back to banner" flows). Keyboard users are unaffected: native Tab
 * traversal doesn't go through HTMLElement.focus, so the banner stays
 * fully reachable and operable — we only stop the unprompted yank.
 * NOT idle-chunked: must be armed before OT's ~2.2s autofocus.
 ********************************************/
(function () {
  let lastOtInput = 0;
  ['pointerdown', 'keydown', 'touchstart'].forEach(ev =>
    addEventListener(ev, e => {
      if (e.isTrusted && e.target && e.target.closest && e.target.closest('#onetrust-consent-sdk')) {
        lastOtInput = performance.now();
      }
    }, { passive: true, capture: true }));
  const nativeFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function () {
    try {
      if (this.closest && this.closest('#onetrust-banner-sdk') && performance.now() - lastOtInput > 1500) {
        window.__emOtFocusSwallowed = (window.__emOtFocusSwallowed || 0) + 1; // marker + diagnostics
        return;
      }
    } catch (_) {}
    return nativeFocus.apply(this, arguments);
  };
})();

/********************************************
 * OneTrust → Shopify Customer Privacy bridge (2026-08-13)
 *
 * OneTrust choices never reached Shopify's consent state (runtime-
 * verified: no _tracking_consent cookie, customerPrivacy API absent —
 * wpm/analytics/checkout ignored banner opt-outs). This syncs OneTrust's
 * active groups into Shopify.customerPrivacy.setTrackingConsent() on
 * banner ready AND on every consent change — OneTrust's own documented
 * integration pattern (developer.onetrust.com/onetrust/docs/ecommerce),
 * applied theme-side to keep the verified consent stack untouched.
 *
 * Group IDs read from the LIVE domain config 2026-08-13
 * (OneTrust.GetDomainData): C0001 Strictly Necessary (not sent),
 * C0002 Performance, C0003 Functional (always active), C0004 Targeting,
 * C0005 Social Media (not in default active set), and SSPD_BG —
 * "Share Or Sale of Personal Data", the DEDICATED branch the
 * Do-Not-Sell flow toggles → maps to sale_of_data.
 *
 * Consent model is opt-out (US): all groups active by default → sends
 * all-true until the user opts out (correct CPRA posture). EU override
 * (?otgeo=de): only strictly-necessary active pre-consent → all-false.
 * Perf: a 250ms typeof-poll until OT is ready (~2s), one small async
 * loadFeatures fetch, one consent POST per actual state change. Nothing
 * on render/interaction paths; NOT idle-chunked (passive sessions must
 * sync too).
 ********************************************/
(function () {
  var MAP = {
    analytics:    ['C0002'],
    preferences:  ['C0003'],
    marketing:    ['C0004'],
    sale_of_data: ['SSPD_BG']
  };
  var lastSent = '';

  function consentFromGroups(groups) {
    var has = function (ids) {
      return ids.some(function (id) { return groups.indexOf(id) !== -1; });
    };
    return {
      analytics:    has(MAP.analytics),
      preferences:  has(MAP.preferences),
      marketing:    has(MAP.marketing),
      sale_of_data: has(MAP.sale_of_data)
    };
  }

  function send() {
    var groups = typeof window.OnetrustActiveGroups === 'string' ? window.OnetrustActiveGroups : null;
    if (groups === null) return;
    var consent = consentFromGroups(groups);
    var key = JSON.stringify(consent);
    if (key === lastSent) return; // idempotence — only push real changes
    var apply = function () {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {
          lastSent = key;
          window.__emShopifyConsentSynced = key; // marker + gates-smoke hook
        });
      } catch (_) {}
    };
    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) { apply(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) apply(); });
    }
  }

  // OT fires this on every consent change (accept / reject / do-not-sell /
  // preference-center save). Dispatch target has varied across OT SDK
  // versions — listen on both.
  addEventListener('OneTrustGroupsUpdated', send);
  document.addEventListener('OneTrustGroupsUpdated', send);

  // Initial state: poll for ~20s (250ms x 80) and do NOT stop at the
  // first read — OT populates OnetrustActiveGroups PROGRESSIVELY during
  // init (C0001-only first, the full template groups a beat later) and
  // fires NO event for that initial settling. Field race caught
  // 2026-08-13: the bridge latched the C0001-only snapshot and synced
  // all-false for a fresh US visitor (over-restrictive, but wrong
  // posture). send() dedupes, so repeated calls only push real changes.
  window.__emBridgeV = 2; // v2 = continuous-poll race fix (also CDN-freshness probe)
  var tries = 0;
  (function poll() {
    if (typeof window.OnetrustActiveGroups === 'string') send();
    if (++tries < 80) setTimeout(poll, 250);
  })();
})();

/********************************************
 * Helpers (shared, global)
 ********************************************/
function runIdle(cb, timeout = 500) {
  if ('requestIdleCallback' in window) {
    try { return window.requestIdleCallback(cb, { timeout }); } catch (_) {}
  }
  return setTimeout(cb, timeout);
}
function preconnect(href, key){
  if (document.querySelector(`link[data-preconnect="${key}"]`)) return;
  const l = document.createElement('link');
  l.rel = 'preconnect'; l.href = href; l.crossOrigin = 'anonymous'; l.dataset.preconnect = key;
  document.head.appendChild(l);
}
function loadOnce(src, key, presenceSubstring, attrs) {
  if (presenceSubstring && document.querySelector(`script[src*="${presenceSubstring}"]`)) return Promise.resolve();
  if (key && document.querySelector(`script[data-key="${key}"]`)) return Promise.resolve();
  return new Promise(res => {
    const s = document.createElement('script');
    s.src = src; s.defer = s.async = true;
    if (key) s.dataset.key = key;
    if (attrs && typeof attrs === 'object') for (const [k,v] of Object.entries(attrs)) try { s.setAttribute(k, v); } catch {}
    s.onload = res; document.head.appendChild(s);
  });
}
const afterIntent = (fn) => {
  let done = false;
  const run = () => { if (done) return; if (scrollY < 60) return; done = true; fn(); };
  ['scroll','click','keydown','touchstart'].forEach(e => addEventListener(e, run, { once:true, passive:true }));
  addEventListener('load', () => setTimeout(run, 8000), { once:true }); // fallback
};
const onThemeReady = (fn) => {
  let fired = false;
  const run = () => { if (fired) return; fired = true; try { fn(); } catch (e) { console.error(e); } };
  document.addEventListener('page:loaded', run, { once: true });
  if (document.readyState === 'interactive' || document.readyState === 'complete') setTimeout(run, 0);
  else document.addEventListener('DOMContentLoaded', run, { once: true });
};
function setCartBusy(on) { document.documentElement.classList.toggle('cart-intent-loading', !!on); }
// Safe Element.closest() from an event target — guards against non-Element targets (text nodes, document, window).
function closestFromEvent(e, selector) {
  const t = e && e.target;
  return (t && typeof t.closest === 'function') ? t.closest(selector) : null;
}

/********************************************
 * 1) Defer AOS
 ********************************************/
onThemeReady(() => {
  if (!window.AOS) return;
  if (matchMedia('(max-width: 767px)').matches) return; // skip mobile
  runIdle(() => {
    try {
      AOS.init({ easing: 'ease-out-quad', once: true, offset: 60, disableMutationObserver: true });
    } catch(e) {}
  }, 500);
});

/********************************************
 * 2) Hero slideshow: static-first
 ********************************************/
onThemeReady(() => {
  const instances = (window.theme?.sections && theme.sections.instances) || [];
  instances
    .filter(s => s && s.type === 'slideshow-section' && s.slideshow)
    .forEach(s => {
      const sectionEl = s.container?.parentElement;
      if (!sectionEl || !sectionEl.parentElement) return;
      const isFirst = [].indexOf.call(sectionEl.parentElement.children, sectionEl) === 0;
      if (!isFirst) return;

      const slides = s.slideshow.querySelectorAll('.slideshow__slide');
      if (slides.length) slides[0].classList.add('is-selected');
      if (s.flickity) return;

      let done = false;
      const initFlickity = () => {
        if (done) return; done = true;
        if (typeof s.forceReload === 'function') s.forceReload();
        else if (typeof s.init === 'function') s.init();
      };
      ['scroll','click','keydown','touchstart'].forEach(ev => window.addEventListener(ev, initFlickity, { once:true, passive:true }));
      runIdle(initFlickity, 1200);
    });
});

/********************************************
 * 3) Newsletter Popup: after intent / 6s
 ********************************************/
const _urlNoPopup = new URLSearchParams(location.search).get('no-popup') === '1';
onThemeReady(() => {
  if (_urlNoPopup) return;
  const np = (theme.sections?.instances || []).find(s => s.type === 'newsletter-popup');
  if (!np) return;
  if (np.modal && typeof np.modal.close === 'function') { try { np.modal.close(); } catch(e){} }

  let opened = false;
  const openLater = () => { if (opened) return; opened = true; if (np.modal?.open) np.modal.open(); };
  ['scroll','click','keydown','touchstart'].forEach(ev => window.addEventListener(ev, openLater, { once:true, passive:true }));
  window.addEventListener('load', () => setTimeout(openLater, 6000), { once:true });
});

/********************************************
 * 4) Predictive Search: bind on focus
 ********************************************/
onThemeReady(() => {
  const ps = document.querySelector('predictive-search input[type="search"]');
  if (!ps) return;
  let wired = false;
  ps.addEventListener('focus', () => {
    if (wired) return; wired = true;
    document.dispatchEvent(new CustomEvent('predictive:activate'));
  }, { once: true, passive: true });
});

/********************************************
 * 5) Smart Cart (Rebuy): robust + adaptive + double-open guard
 *    - Records actual time-to-ready (adaptive patience)
 *    - PDP idle prewarm @ 1500ms
 *    - Confirmed-down grace = 700ms
 *    - OPEN LOCK + RECENT-CLOSE guard (prevents reopen after close)
 *    - Wrap Rebuy's own .open() so it respects our guards
 ********************************************/
(function(){
  const DEBUG = false;

  const REBUY = {
    loading:false, ready:false, downUntil:0, lastAttempt:0, backoff:0,
    everTried:false, everReady:false, failCount:0, lastErrorAt:0,
    lastReadyMs: null
  };

  // NEW: double-open prevention
  let OPEN_LOCK_UNTIL = 0;        // block new opens for a short window after we call open
  let LAST_USER_CLOSE_AT = 0;     // if user closes, don't reopen immediately

  // (page-load Rebuy preconnects removed 2026-08-05 — Rebuy loads on
  // intent/delay, so early connections idled out before use (PSI "unused
  // preconnect"); __openRebuyGate preconnects just-in-time instead.)

  function log(...a){ if (DEBUG) console.log('[Rebuy]', ...a); }

  function noteFailure() {
    const now = Date.now();
    if (now - REBUY.lastErrorAt > 30000) REBUY.failCount = 0;
    REBUY.lastErrorAt = now; REBUY.failCount += 1;
    if (REBUY.failCount >= 2) {
      const backoff = Math.min(60000, REBUY.backoff ? REBUY.backoff*2 : 5000);
      REBUY.backoff = backoff; REBUY.downUntil = now + backoff;
      log('marked down for', backoff, 'ms');
    }
  }

  // Ensure our gate is open before attempting to load (works with your Section 0 gate)
  function gateSafeOpen(){
    try {
      if (window.GATE_REBUY && typeof window.__openRebuyGate === 'function') {
        window.__openRebuyGate();
        log('gate opened');
      }
    } catch(_) {}
  }

  function guardRebuyOpeners(){
    try {
      const guardFn = (orig) => {
        if (!orig || orig.__guarded) return orig;
        const wrapped = function(...args){
          const now = Date.now();
          if (now < OPEN_LOCK_UNTIL) { log('open blocked by lock'); return; }
          if (now - LAST_USER_CLOSE_AT < 800) { log('open blocked (recent close)'); return; }
          OPEN_LOCK_UNTIL = now + 1200;
          return orig.apply(this, args);
        };
        wrapped.__guarded = true;
        wrapped.__orig = orig; // let our own opener bypass the lock
        return wrapped;
      };
      if (window.Rebuy?.SmartCart) {
        const sc = window.Rebuy.SmartCart;
        if (sc.open)  sc.open  = guardFn(sc.open);
        if (sc.show)  sc.show  = guardFn(sc.show);
        if (sc.toggle) sc.toggle = guardFn(sc.toggle);
      }
      if (window.Rebuy?.Cart) {
        const c = window.Rebuy.Cart;
        if (c.open)  c.open  = guardFn(c.open);
        if (c.toggle) c.toggle = guardFn(c.toggle);
      }
    } catch(_) {}
  }

  function ensureRebuy(cb){
    cb = cb || (()=>{});
    const now = Date.now(); REBUY.everTried = true;

    if (window.Rebuy && (window.Rebuy.SmartCart || window.Rebuy.init)) {
      try { window.Rebuy.init && window.Rebuy.init(); } catch(_) {}
      REBUY.ready = true; REBUY.loading = false; REBUY.everReady = true;
      guardRebuyOpeners(); // make sure open() is guarded even on already-present
      log('already present → init');
      return void cb();
    }
    if (now < REBUY.downUntil) { log('in down window'); return void cb(new Error('rebuy_down')); }
    if (REBUY.loading || (now - REBUY.lastAttempt < 800)) { log('throttled'); return void cb(); }

    gateSafeOpen();
    REBUY.loading = true; REBUY.lastAttempt = now;
    log('loading script…');

    loadOnce(
      'https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=' + (window.Shopify && Shopify.shop ? Shopify.shop : 'ella-mila-inc.myshopify.com'),
      'rebuy-global',
      'cdn.rebuyengine.com/onsite/js/rebuy.js',
      {'data-gate-allow':'1'}
    )
    .then(()=>{
      const t0 = performance.now(); // measure "ready" after fetch
      (function waitReady(){
        const ok = !!(window.Rebuy && (window.Rebuy.SmartCart || window.Rebuy.init));
        if (ok){
          try { window.Rebuy.init && window.Rebuy.init(); } catch(_) {}
          REBUY.ready = true; REBUY.loading = false; REBUY.backoff = 0;
          REBUY.everReady = true; REBUY.failCount = 0;
          REBUY.lastReadyMs = Math.round(performance.now() - t0);
          log('ready in', REBUY.lastReadyMs, 'ms (post-fetch)');

          // Guard Rebuy's own openers so they respect close/lock
          guardRebuyOpeners();

          // Re-guard shortly after init, in case Rebuy rebinds methods
          let tries = 0;
          const t = setInterval(()=>{ guardRebuyOpeners(); if (++tries > 20) clearInterval(t); }, 100);

          return void cb();
        }
        if (performance.now() - t0 > 3000) {
          REBUY.loading = false; noteFailure(); log('timeout waiting ready');
          return void cb(new Error('rebuy_timeout'));
        }
        setTimeout(waitReady, 50);
      })();
    })
    .catch(()=>{
      REBUY.loading=false; noteFailure(); log('load failed');
      cb(new Error('rebuy_load_failed'));
    });
  }
  window.ensureRebuy = ensureRebuy;

  function isSmartCartOpen(){
    try {
      if (window.Rebuy?.SmartCart?.state?.isOpen !== undefined) return !!window.Rebuy.SmartCart.state.isOpen;
      if (window.Rebuy?.SmartCart?.isOpen  !== undefined)       return !!window.Rebuy.SmartCart.isOpen;
    } catch(_) {}
    // .is-visible: Rebuy's CURRENT open-state class (verified 2026-08-06);
    // older variants kept for safety.
    return !!document.querySelector(
      '.rebuy-cart.is-visible, .rebuy-cart.is-open, .rebuy-cart.open, .rebuy-cart--visible, [data-rebuy-smartcart].is-open, [data-rebuy-cart].is-open'
    );
  }

  function openSmartCartIfPossible(){
    const now = Date.now();
    if (now < OPEN_LOCK_UNTIL) return false;
    if (isSmartCartOpen()) return true;
    try {
      // Rebuy's current API is SmartCart.show() (verified 2026-08-06 — open()
      // and toggle() no longer exist on their new SmartCart, which is why the
      // cold path always fell back to the theme drawer). Call the unguarded
      // original (fn.__orig) so our own OPEN_LOCK doesn't block our own open.
      const sc = window.Rebuy?.SmartCart, c = window.Rebuy?.Cart;
      const f = (sc && (sc.show || sc.open)) || (c && (c.open || c.toggle));
      const self = (sc && (sc.show || sc.open)) ? sc : c;
      if (f) { OPEN_LOCK_UNTIL = now + 1200; (f.__orig || f).call(self); return true; }
    } catch(_) {}
    return false;
  }

  // ADAPTIVE patience based on observed ready time + network RTT
  function currentPatience(defaultMs) {
    if (REBUY.everReady) return 400; // snappy after first success
    if (REBUY.everTried) {
      const rtt = (navigator.connection && typeof navigator.connection.rtt === 'number')
        ? Math.min(Math.max(navigator.connection.rtt, 50), 600)
        : 300;
      const observed = REBUY.lastReadyMs || 3800;   // your bumped baseline
      const adaptive = observed + 500 + rtt;        // cushion
      return Math.max(3000, Math.min(5200, adaptive));
    }
    return defaultMs; // first path (caller passes 4500)
  }

  // Wait for open/confirmed fail; confirmed-down grace = 700ms
  function waitSmartCartOrFail(maxMs, minWaitMs = 700) {
    return new Promise(resolve => {
      const t0 = performance.now();
      let attemptedAt = 0;
      (function poll(){
        const now = performance.now();

        // If already open, done
        if (isSmartCartOpen()) return resolve('opened');

        // If user just closed, don't reopen
        if (Date.now() - LAST_USER_CLOSE_AT < 800) return resolve('closed');

        // ATTEMPT an open (once per lock window) but do NOT trust the call:
        // SmartCart.show() during Rebuy's boot is a silent no-op (cart DOM not
        // built yet — 2026-08-06), which used to resolve 'opened' with nothing
        // on screen. Only the VISIBLE state (isSmartCartOpen, next poll)
        // counts; the lock throttles retries to ~1 per 1.2s until it sticks.
        if (openSmartCartIfPossible() && !attemptedAt) attemptedAt = now;
        if (isSmartCartOpen()) return resolve('opened');

        const waited = now - t0;
        const confirmedDown = Date.now() < REBUY.downUntil;
        if (confirmedDown && waited >= minWaitMs && !attemptedAt) return resolve('failed');
        // Once an open has been ATTEMPTED, always allow >=1500ms for the
        // drawer's visible class to flip — Firefox's Vue transition is slower
        // than the 400ms warm-path patience and the premature timeout was
        // opening the THEME drawer a beat before SmartCart appeared
        // (2026-08-07, Ara's Firefox desktop repro).
        const deadline = attemptedAt ? Math.max(maxMs, (attemptedAt - t0) + 1500) : maxMs;
        if (waited >= deadline) return resolve('timeout');
        setTimeout(poll, 50);
      })();
    });
  }

  function clickBypass(el) {
    if (!el) return false;
    document.body.setAttribute('data-disable-smartcart-intercept','1');
    try { el.click(); } catch(_) {}
    document.body.removeAttribute('data-disable-smartcart-intercept');
    return true;
  }

  function openThemeCartDrawer(triggerEl){
    const known = document.querySelector(
      '[data-cart-toggle], .js-drawer-open-cart, button[data-action="open-drawer"][data-drawer-id*="cart"], button[aria-controls*="Cart"], button[aria-controls*="cart"]'
    );
    if (known) return clickBypass(known);
    if (triggerEl) return clickBypass(triggerEl);
    location.href = '/cart';
    return false;
  }

  const CART_SELECTORS = [
    '[data-cart-toggle]',
    '.js-drawer-open-cart',
    'button[data-action="open-drawer"][data-drawer-id*="cart"]',
    'button[aria-controls*="Cart"]',
    'button[aria-controls*="cart"]',
    '.header__icon--cart',
    '.header__icon.header__icon--cart',
    '.site-header__icons .cart-link',
    '.header__action-item--cart a',
    'a[href="/cart"]',
    'a[href^="/cart"]'
  ].join(',');

  // Track user-initiated close (close button, overlay, ESC)
  document.addEventListener('click', (e)=>{
    const c = closestFromEvent(e, '[data-rebuy-close], .rebuy-cart__close, .rebuy-cart-close, .rebuy-cart__overlay, .rebuy-overlay');
    if (c) LAST_USER_CLOSE_AT = Date.now();
  }, true);
  document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape') LAST_USER_CLOSE_AT = Date.now();
  }, true);

  // Pre-warm on intent (hover/focus) – open gate first
  onThemeReady(() => {
    const warm = () => { gateSafeOpen(); window.ensureRebuy?.(()=>{}); };
    document.addEventListener('pointerenter', (e)=>{
      const t = closestFromEvent(e, CART_SELECTORS); if (t) warm();
    }, {passive:true});
    document.addEventListener('focusin', (e)=>{
      const t = closestFromEvent(e, CART_SELECTORS); if (t) warm();
    });
  });

  // Prewarm strategy (2026-08-06, TBT audit): first-interaction on all pages
  // (was: PDP-only idle+1.5s — an unconditional load that ran ~1s of Rebuy JS
  // inside every lab trace). Any gesture — scroll, mouse movement, touch, key —
  // starts the load, so by the time a pointer reaches the cart icon the bundle
  // is warming (mousemove fires en route; touchstart fires at tap-start). The
  // click interceptor below already handles the not-yet-ready case: load →
  // wait → open SmartCart, theme-drawer fallback on failure. EXCEPTION: the
  // /cart page renders visible Rebuy widgets (empty-cart CTA, recommendations)
  // — load immediately there so the page isn't half-empty.
  onThemeReady(()=>{
    if (document.body.classList.contains('template-cart')) {
      gateSafeOpen(); window.ensureRebuy?.(()=>{});
      return;
    }
    let warmed=false;
    const warmOnce=(e)=>{ if(e && e.isTrusted === false) return; if(warmed) return; warmed=true; gateSafeOpen(); window.ensureRebuy?.(()=>{}); };
    ['wheel','mousemove','touchstart','keydown','click'].forEach(ev=>
      addEventListener(ev, warmOnce, {passive:true, capture:true}));
  });

  // Intercept clicks → prefer SmartCart; fallback only on failure/timeout
  document.addEventListener('click', async function(e){
    if (e.isTrusted === false) return; // synthetic clicks pass through (clickBypass, vendor scripts)
    const t = closestFromEvent(e, CART_SELECTORS);
    if (!t) return;
    if (document.body.hasAttribute('data-disable-smartcart-intercept')) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

    try {
      // COLD TAP (2026-08-06 rev 2): Rebuy not booted yet — show the
      // "Opening cart…" chip for feedback and give SmartCart a bounded window
      // to boot and open (users prefer the Rebuy cart with the progress bar
      // over the plain theme drawer — Ara). Theme drawer only on timeout.
      const rebuyBooted = !!(window.Rebuy && (window.Rebuy.SmartCart || window.Rebuy.init));
      gateSafeOpen(); ensureRebuy(()=>{});
      if (!rebuyBooted) {
        document.documentElement.classList.add('em-cart-pending');
        const r = await waitSmartCartOrFail(6000, 400);
        document.documentElement.classList.remove('em-cart-pending');
        if (r !== 'opened' && r !== 'closed') openThemeCartDrawer(t);
        return;
      }
      setCartBusy(true);
      const patience = currentPatience(4500);
      const result = await waitSmartCartOrFail(patience, 700);
      setCartBusy(false);
      if (result === 'opened' || result === 'closed') return; // don't fallback if user just closed
      openThemeCartDrawer(t);
    } catch (err) {
      console.error('[SmartCart intercept]', err);
      setCartBusy(false);
      document.documentElement.classList.remove('em-cart-pending');
      openThemeCartDrawer(t);
    }
  }, true);

  // Hand-off from the early cart-tap catcher in theme.liquid (2026-08-06):
  // taps that landed before this script initialized were held (preventDefault,
  // __emPendingCart flag). Now that the interceptor + theme drawer exist,
  // release: mark ready, drop the early handler, and open the drawer for any
  // pending tap. theme.js executes before custom.js (defer order), so the
  // theme drawer is available here.
  window.__emCartReady = true;
  try { if (window.__emEarlyCartH) document.removeEventListener('click', window.__emEarlyCartH, true); } catch(_) {}
  if (window.__emPendingCart) {
    window.__emPendingCart = false;
    // Keep the chip up and give SmartCart a bounded boot window (rev 2 —
    // prefer the Rebuy cart on held early taps too); theme drawer on timeout.
    gateSafeOpen(); ensureRebuy(()=>{});
    waitSmartCartOrFail(8000, 400).then(r => {
      document.documentElement.classList.remove('em-cart-pending');
      if (r !== 'opened' && r !== 'closed') openThemeCartDrawer(document.querySelector('.site-header__icons a[href*="cart"], .cart-link'));
    }).catch(() => {
      document.documentElement.classList.remove('em-cart-pending');
      openThemeCartDrawer(document.querySelector('.site-header__icons a[href*="cart"], .cart-link'));
    });
  } else {
    document.documentElement.classList.remove('em-cart-pending');
  }

  // Landed on Rebuy's cart-redirect target (/?viewcart=true — its Smart Cart
  // setting redirects /cart here expecting the drawer to auto-open, which a
  // cold gated Rebuy can't do). Honor the intent: open the cart.
  if (/[?&]viewcart=true/.test(location.search)) {
    onThemeReady(()=>{
      gateSafeOpen(); ensureRebuy(()=>{});
      waitSmartCartOrFail(6000, 400).then(r => {
        if (r !== 'opened') { OPEN_LOCK_UNTIL = 0; if (!openSmartCartIfPossible()) openThemeCartDrawer(); }
      }).catch(()=>{ openThemeCartDrawer(); });
    });
  }

  // AJAX add → prefer SmartCart (avoid reopen after user close)
  document.addEventListener('ajaxProduct:added', async (e)=>{
    try {
      e.stopImmediatePropagation?.(); e.stopPropagation?.(); e.preventDefault?.();
      // Same cold-state rule as the click intercept: item was just added —
      // show the theme drawer immediately rather than a silent wait.
      const rebuyBooted = !!(window.Rebuy && (window.Rebuy.SmartCart || window.Rebuy.init));
      gateSafeOpen(); ensureRebuy(()=>{});
      if (!rebuyBooted) { openThemeCartDrawer(); return; }
      setCartBusy(true);
      const result = await waitSmartCartOrFail(currentPatience(3000), 600);
      setCartBusy(false);
      if (result === 'opened' || result === 'closed') return;
      openThemeCartDrawer();
    } catch (err) {
      console.error('[ajaxProduct:added]', err);
      setCartBusy(false);
      openThemeCartDrawer();
    }
  }, true);

  window.addEventListener('error', (e)=>{
    const src = (e?.filename || '') + ' ' + (e?.message || '');
    if (src.includes('rebuyengine.com') || src.includes('cached.rebuyengine.com')) noteFailure();
  }, true);
  window.addEventListener('unhandledrejection', (e)=>{
    const msg = String(e.reason || '');
    if (msg.includes('rebuyengine') || msg.includes('cached.rebuyengine.com')) noteFailure();
  }, true);
})();

/********************************************
 * 6) Rebuy widgets (NOT Smart Cart): IO load (no forced Rebuy)
 ********************************************/
onThemeReady(() => {
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if (!e.isIntersecting) return;
      if (e.target.matches('[data-rebuy-id]')) {
        // Only init if Rebuy is already present; do NOT load Rebuy here
        if (window.Rebuy) { try { window.Rebuy.init(); } catch(_){} }
      }
      io.unobserve(e.target);
    });
  }, { rootMargin: '50px', threshold: 0.01 });

  document.querySelectorAll('[data-rebuy-id]').forEach(el => io.observe(el));
});

/********************************************
 * 7) Gorgias chat (lazy; single flag) + 5gtb chained
 ********************************************/
(function(){
  if (!window.ENABLE_GORGIAS) return;

  // Interaction-ONLY (2026-08-10; previously interaction + 6s post-load
  // fallback timer). The timer fired inside Lighthouse's observation window
  // — ~1.1s of chat scripting landing in every lab run's TBT (found in the
  // collection-page audit). Same doctrine as the Attentive/Klaviyo/Okendo
  // gates: no timers; a session that never scrolls, moves, or taps can't
  // click a chat bubble either. Trusted events only ('wheel' not 'scroll' —
  // programmatic scrollIntoView fires trusted document scrolls; synthetic
  // clicks like the PDP clickSecondThumb are isTrusted:false).
  function afterIntentLocal(fn) {
    let done = false;
    const fire = (e) => {
      if (e && e.isTrusted === false) return;
      if (done) return; done = true;
      events.forEach(([ev, h]) => removeEventListener(ev, h));
      fn();
    };
    const events = [['wheel', fire], ['mousemove', fire], ['click', fire], ['keydown', fire], ['touchstart', fire]];
    events.forEach(([ev, h]) => addEventListener(ev, h, { passive: true }));
  }

  const load5gtb = () => {
    if (window._5gtb || document.querySelector('script[src*="bundle.5gtb.com/loader.js"]')) return;
    preconnect('https://bundle.5gtb.com', 'fivegtb');
    loadOnce('https://bundle.5gtb.com/loader.js', '5gtb', 'bundle.5gtb.com/loader.js', {'data-gate-allow':'1'});
  };

  const loadGorgias = () => {
    if (window.Gorgias || window.GorgiasChat ||
        document.querySelector('script[src*="config.gorgias.chat/bundle-loader"]')) {
      setTimeout(load5gtb, 1500);
      return;
    }
    preconnect('https://config.gorgias.chat', 'gorgias-cfg');
    loadOnce(
      'https://config.gorgias.chat/bundle-loader/01GYCC2V8TAZQA6SJ3A6ZFRG65',
      'gorgias-bundle-loader',
      'config.gorgias.chat/bundle-loader',
      { id: 'gorgias-chat-widget-install-v3', 'data-gate-allow':'1' }
    ).then(() => setTimeout(load5gtb, 1200))
     .catch(() => runIdle(() => {
       loadOnce(
         'https://config.gorgias.chat/bundle-loader/01GYCC2V8TAZQA6SJ3A6ZFRG65',
         'gorgias-bundle-loader',
         'config.gorgias.chat/bundle-loader',
         { id: 'gorgias-chat-widget-install-v3', 'data-gate-allow':'1' }
       ).then(() => setTimeout(load5gtb, 1200));
     }, 1500));
  };

  // manual trigger for testing
  window.__loadGorgiasNow = loadGorgias;

  // PDP behavior is flag-driven (see ENABLE_GORGIAS_PDP at the top of
  // this file). Off: skip entirely — don't pay ~630KB of Gorgias +
  // Convert on product pages (bubble would overlay the sticky ATC).
  // On: load as usual and tag the body so custom.css lifts the bubble
  // clear of the sticky ATC bar.
  const isPDP = document.body.classList.contains('template-product');
  if (isPDP) {
    if (!window.ENABLE_GORGIAS_PDP) return;
    document.body.classList.add('gorgias-on-pdp');
  }

  // Intent-based load (2026-07-11; previously idle/intent mix): load on
  // first meaningful interaction so the ~570KB chat bundle never
  // competes with the critical window; passive viewers get the bubble
  // via the post-load fallback timer. Scroll-quiet (2026-08-11): the
  // ~570KB bundle parse was part of the mid-flick burst killing iOS
  // momentum — wait for scrolling to settle like the other gates.
  afterIntentLocal(() => window.__emScrollQuiet(loadGorgias));
})();

/********************************************
 * 8) Quick-add for Featured + Related
 ********************************************/
(() => {
  const COLLECTION = [
    '[id^="shopify-section-"][id$="main-collection"]',
    '[data-section-type="collection-grid"]',
    '[data-section-type="collection-grid"][data-context="main-collection"]'
  ].join(', ');
  const FEATURED = [
    '[id^="shopify-section-"][id$="featured-collection"]',
    '[data-section-type="featured-collection"]',
    '[data-section-type="collection-grid"][data-context="featured-collection"]'
  ].join(', ');
  const RECS = [
    'product-recommendations',
    '[id^="shopify-section-"][id*="product-recommendations"]',
    '[data-section-type="product-recommendations"]',
    '[data-section-type="related-products"]'
  ].join(', ');
  const ROOTS = `${COLLECTION}, ${FEATURED}, ${RECS}`;
  const CARD_SEL = '.grid-product';
  const BTN_HTML = `
    <button type="button" name="add" data-add-to-cart class="btn btn--full add-to-cart qa-btn">
      <span data-add-to-cart-text data-default-text="Add to cart">Add to cart</span>
    </button>
  `;
  //class="btn--secondary"

  const getHandleFromCard = c => c?.dataset?.productHandle || c?.getAttribute('data-product-handle') || null;
  const getLinkFromCard = c => c.querySelector('a.grid-product__link');
  const hrefToHandle = href => {
    try { const u=new URL(href,location.origin),p=u.pathname.split('/').filter(Boolean),i=p.indexOf('products'); return i>=0?p[i+1]:null; } catch { return null; }
  };

  const fetchProduct = async h => {
    const r = await fetch(`/products/${h}.js`, { headers:{Accept:'application/json'} });
    if (!r.ok) throw new Error('Product JSON not found'); return r.json();
  };
  const firstAvail = p => (p.variants && (p.variants.find(v=>v.available) || p.variants[0])) || null;
  const setBusy = b => { b.classList.add('btn--loading'); b.setAttribute('aria-busy','true'); b.disabled = true; };
  const clearBusy = b => { b.classList.remove('btn--loading'); b.removeAttribute('aria-busy'); b.disabled = false; };
  const ajaxAdd = async (id,q=1) => {
    const r = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id,quantity:q})});
    if(!r.ok) throw new Error('Add to cart failed'); return r.json();
  };

  const onAdd = async (btn, card, evt) => {
    evt?.preventDefault?.(); evt?.stopPropagation?.(); evt?.stopImmediatePropagation?.();
    setBusy(btn);
    try{
      const link = getLinkFromCard(card);
      const handle = getHandleFromCard(card) || (link ? hrefToHandle(link.href) : null);
      if(!handle) throw new Error('No handle');
      const prod = await fetchProduct(handle);
      // if((prod.options?.length||0)>1){ clearBusy(btn); return link&&(location.href=link.href); }
      const v = firstAvail(prod);
      if(!v){ clearBusy(btn); return link&&(location.href=link.href); }
      const added = await ajaxAdd(v.id,1);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:added,addToCartBtn:btn},bubbles:true}));
    }catch(e){
      console.error('[quick-add]',e);
      const link=getLinkFromCard(card); if(link) location.href=link.href;
    }finally{ clearBusy(btn); }
  };

  function injectIn(root){
    if(!root) return;
    root.querySelectorAll(CARD_SEL).forEach(card=>{
      if(card.querySelector('button.qa-btn')) return;
      if(card.querySelector('[data-product-form], [data-quick-add], button[name="add"]')) return;

      const meta = card.querySelector('.grid-product__meta');
      const target = meta || card.querySelector('.grid-product__content') || card;
      if(!target) return;

      const wrap = document.createElement('div'); wrap.innerHTML = BTN_HTML.trim();
      const btn = wrap.firstChild;
      btn.style.position='relative'; btn.style.zIndex='10'; btn.style.pointerEvents='auto';

      const cancel = e=>{ e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); };
      // pointerdown alone covers touch + mouse + pen; redundant touchstart listener removed to satisfy Lighthouse passive-listener audit.
      btn.addEventListener('pointerdown', cancel, true);
      let fired=false;
      const handle = e=>{ if(fired) return; fired=true; onAdd(btn,card,e); setTimeout(()=>fired=false,600); };
      btn.addEventListener('click', handle);
      btn.addEventListener('pointerup', e=>{ cancel(e); handle(e); }, true);

      target.appendChild(btn);
    });
  }

  function scanAll(){
    document.querySelectorAll(ROOTS).forEach(injectIn);
  }

  const init = () => { scanAll(); setTimeout(scanAll, 400); setTimeout(scanAll, 1200); };

  const observeRoots = () => {
    document.querySelectorAll(ROOTS).forEach(root=>{
      const mo = new MutationObserver(()=>injectIn(root));
      mo.observe(root, {childList:true, subtree:true});
    });
  };
  // Idle-chunked (2026-08-13 TBT pass): quick-add is secondary UI — buttons
  // appearing ~1s post-idle is invisible, and pre-idle the cards simply
  // behave pre-enhancement. Moves 3 full-DOM scans + observer attachment
  // out of the DCL window. (The eval-time observeRoots call this replaces
  // also ran before the roots existed — it attached to nothing.)
  window.__emIdleV = 2; // marker: TBT idle-chunk pass v2 (CDN-freshness probe)
  const start = () => runIdle(() => { init(); observeRoots(); }, 1200);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();

  ['shopify:section:load','shopify:section:select','shopify:section:deselect','shopify:section:unload','shopify:block:select','shopify:block:deselect','recommendations:loaded','page:loaded']
    .forEach(evt=>document.addEventListener(evt, ()=>{ scanAll(); observeRoots(); }));
})();

/********************************************
 * 9) LCP hint: promote likely hero/product image
 *    Best fix is parse-time in Liquid (image_tag preload/fetchpriority).
 *    Runtime fallback below also injects a <link rel="preload"> to lift
 *    priority for templates where the Liquid hasn't been updated yet.
 ********************************************/
onThemeReady(() => {
  // More-specific selectors first so PDP/slideshow images win; img.image-element
  // is a broad fallback for any vanilla Impulse image rendered via the
  // image-element snippet.
  const cand = document.querySelector(
    '.slideshow__slide img, .product-single__photos img, .product-media img, .product__photo img, img.image-element'
  );
  if (!cand) return;

  if (!cand.hasAttribute('fetchpriority')) {
    cand.setAttribute('fetchpriority', 'high');
    cand.setAttribute('decoding', 'async');
  }

  try {
    if (!document.querySelector('link[data-preload="lcp-img"]')) {
      const l = document.createElement('link');
      l.rel = 'preload';
      l.as = 'image';
      l.dataset.preload = 'lcp-img';
      if (cand.srcset) l.setAttribute('imagesrcset', cand.srcset);
      if (cand.sizes)  l.setAttribute('imagesizes', cand.sizes);
      l.href = cand.currentSrc || cand.src;
      if (l.href) document.head.appendChild(l);
    }
  } catch(_) {}
});

/* === Sticky ATC toggle === */
(() => {
  if (!window.ENABLE_STICKY_ATC) return;
  // Sticky ATC only makes sense on product pages; bail early elsewhere so we
  // don't run getPDPBits() against missing markup (previously threw on homepage).
  if (!document.body.classList.contains('template-product')) return;

  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  // Defensive: allow `null`/`undefined` root → fall back to document.
  const qs = (sel, root) => (root || document).querySelector(sel);
  const qsa = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const buildBar = () => {
    // Build once
    if (qs('#em-sticky-atc')) return qs('#em-sticky-atc');

    const bar = document.createElement('div');
    bar.id = 'em-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    // Landmark so bar content isn't orphaned outside <main> (axe "region" rule)
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
//    bar.innerHTML = `
//      <div class="em-sticky-wrap">
//        <div class="em-sticky-title"></div>
//        <div class="em-sticky-price"></div>
//        <button type="button" class="em-sticky-btn">Add to cart</button>
//      </div>
//    `;
    bar.innerHTML = `
      <div class="em-sticky-wrap">
        <div class="em-sticky-title"></div>
        <div class="em-sticky-price"></div>
        <button type="submit" name="add" data-add-to-cart="" class="btn btn--full add-to-cart em-sticky-btn">
          <span data-add-to-cart-text="" data-default-text="Add to cart">Add to cart</span>
        </button>
      </div>
    `;
    document.body.appendChild(bar);
    return bar;
  };

  const getPDPBits = () => {
    const meta = qs('.product-single__meta');
    const titleEl = qs('.product-single__title', meta) || qs('h1.h2');
    const priceEl = qs('.product-block--price .product__price', meta);
    // Real PDP form/button
    const form = qs('.product-single__form', meta) || qs('form[action="/cart/add"]', meta);
    const btn = form ? qs('button[name="add"]', form) : null;
    return { meta, titleEl, priceEl, form, btn };
  };

  const copyText = (el) => (el ? el.textContent.trim() : '');

  const init = () => {
    const { meta, titleEl, priceEl, form, btn } = getPDPBits();
    if (!meta || !form || !btn) {
      // Keep looking a bit longer—Impulse can lazy render
      let tries = 0;
      const t = setInterval(() => {
        const bits = getPDPBits();
        if (bits.meta && bits.form && bits.btn) {
          clearInterval(t);
          wire(bits);
        } else if (++tries > 20) {
          clearInterval(t);
        }
      }, 150);
      return;
    }
    wire({ meta, titleEl, priceEl, form, btn });
  };

  const wire = ({ meta, titleEl, priceEl, form, btn }) => {
    const bar = buildBar();
    const t = qs('.em-sticky-title', bar);
    const p = qs('.em-sticky-price', bar);
    const b = qs('.em-sticky-btn', bar);

    t.textContent = copyText(titleEl) || 'Product';
    p.textContent = copyText(priceEl) || '';

    // --- OOS / KLAVIYO BACK-IN-STOCK STATE ---
    // Modes: 'atc'        — normal add-to-cart mirroring (default)
    //        'notify'     — sold out AND a Klaviyo back-in-stock trigger exists
    //                       → sticky button opens the BIS form instead
    //        'oos-hidden' — sold out, no trigger → bar never shows. A disabled
    //                       "Sold out" pinned to the viewport is dead weight,
    //                       and a "Notify me" with nothing behind it is worse.
    let mode = 'atc';
    let bisTrigger = null;
    let btnOutOfView = false;

    const soldOutText = ((window.theme && theme.strings && theme.strings.soldOut) || 'Sold out').trim().toLowerCase();
    const isSoldOut = () => {
      const label = btn.querySelector('[data-add-to-cart-text]');
      return !!btn.disabled && !!label && label.textContent.trim().toLowerCase() === soldOutText;
    };

    // Klaviyo's onsite embed injects a "Notify me when back in stock" button
    // into the product form area when the product is OOS and a BIS sign-up
    // form is published in Klaviyo admin. Verified markup on this store
    // (2026-08-01): <div id="klaviyo-bis-button-container"><button
    // data-a11y-identifier="bis-button-..." class="needsclick go... kl-private-...">
    // — note the classes are obfuscated, only the container id and the
    // a11y-identifier are stable hooks. .klaviyo-bis-trigger is Klaviyo's
    // documented class for hand-placed triggers (old theme used it); kept as
    // a fallback. Scope to the meta column so unrelated Klaviyo embeds
    // elsewhere on the page can't match.
    const findBisTrigger = () => {
      const scope = meta || document;
      return qs('#klaviyo-bis-button-container button, [data-a11y-identifier^="bis-button"], .klaviyo-bis-trigger, [id*="klaviyo" i] button', scope);
    };

    const applyVisibility = () => {
      const show = btnOutOfView && mode !== 'oos-hidden';
      bar.classList.toggle('em-sticky--show', show);
      if (show) bar.removeAttribute('aria-hidden');
      else bar.setAttribute('aria-hidden', 'true');
    };

    // --- SYNC LOADING/STATE WITH REAL BUTTON ---
    const syncFromRealBtn = () => {
      if (mode === 'notify') return;     // notify mode owns the button state
      const loading = btn.classList.contains('btn--loading');
      b.classList.toggle('btn--loading', loading);
      b.disabled = !!btn.disabled;

      if (loading) b.setAttribute('aria-busy','true'); else b.removeAttribute('aria-busy');

      // keep visible label in sync (themes sometimes swap text to "Adding…" / "Added")
      const realLabel = btn.querySelector('[data-add-to-cart-text]');
      const stickyLabel = b.querySelector('[data-add-to-cart-text]');
      if (realLabel && stickyLabel) stickyLabel.textContent = realLabel.textContent;
    };

    const refreshMode = () => {
      if (!isSoldOut()) {
        if (mode !== 'atc') { mode = 'atc'; bisTrigger = null; syncFromRealBtn(); }
        applyVisibility();
        return;
      }
      bisTrigger = findBisTrigger();
      mode = bisTrigger ? 'notify' : 'oos-hidden';
      if (mode === 'notify') {
        b.disabled = false;
        b.classList.remove('btn--loading');
        b.removeAttribute('aria-busy');
        const stickyLabel = b.querySelector('[data-add-to-cart-text]');
        if (stickyLabel) stickyLabel.textContent = copyText(bisTrigger) || 'Notify me when available';
      }
      applyVisibility();
    };

    syncFromRealBtn();
    refreshMode();

    const btnObserver = new MutationObserver(() => { syncFromRealBtn(); refreshMode(); });
    btnObserver.observe(btn, { attributes: true, attributeFilter: ['class','aria-busy','disabled'] });

    // Klaviyo injects its trigger asynchronously after klaviyo.js loads —
    // watch the meta column so a sold-out-on-load product upgrades from
    // 'oos-hidden' to 'notify' the moment the trigger appears.
    if (meta) {
      const bisObserver = new MutationObserver(() => {
        if (isSoldOut()) refreshMode();
      });
      bisObserver.observe(meta, { childList: true, subtree: true });
    }

    // --- STICKY CLICK DELEGATES TO REAL BUTTON + SETS LOADING IMMEDIATELY ---
    b.addEventListener('click', (e) => {
      e.preventDefault();
      if (mode === 'notify') {
        // Klaviyo's document-level delegated handler opens the BIS form
        if (bisTrigger) bisTrigger.click();
        return;
      }
      if (b.disabled) return;            // prevent double taps
      b.classList.add('btn--loading');
      b.setAttribute('aria-busy','true');
      btn.click();                       // fires the theme's normal add flow

      // safety: clear after 8s in case no theme event fires
      clearTimeout(b._emTimeout);
      b._emTimeout = setTimeout(() => {
        b.classList.remove('btn--loading');
        b.removeAttribute('aria-busy');
      }, 8000);
    });

    // Clear sticky loading when cart add completes (Impulse fires this)
    document.addEventListener('ajaxProduct:added', () => {
      b.classList.remove('btn--loading');
      b.removeAttribute('aria-busy');
    });

    // --- INTERSECTION OBSERVER ---
    const io = new IntersectionObserver(([entry]) => {
      btnOutOfView = !(entry && entry.isIntersecting);
      applyVisibility();
    }, { root: null, threshold: 0, rootMargin: '0px 0px -20% 0px' });
    io.observe(btn);

    // --- LIVE PRICE UPDATES (unchanged) ---
    const priceRoot = priceEl && priceEl.parentElement ? priceEl.parentElement : priceEl;
    if (priceRoot) {
      const mo = new MutationObserver(() => { p.textContent = copyText(priceEl) || p.textContent; });
      mo.observe(priceRoot, { characterData: true, subtree: true, childList: true });
    }

    // Optional: hide while cart/drawer opens
    ['cart:open','drawer:open'].forEach(evt => {
      document.addEventListener(evt, () => {
        bar.classList.remove('em-sticky--show');
        bar.setAttribute('aria-hidden','true');
      });
    });
  };

  // Idle-chunked (2026-08-13 TBT pass): the bar only matters after the
  // shopper scrolls past the real ATC button — a ~1s idle defer is
  // invisible (the IntersectionObserver evaluates immediately on wire, so
  // even a fast scroller just sees the bar appear the moment init lands).
  // Moves the PDP-bits polling + bar construction out of the DCL window.
  onReady(() => runIdle(init, 1000));
})();


/* === Okendo stars in collection grid === */
(() => {
  // flip to false to disable quickly
  const ENABLE_GRID_STARS = true;
  if (!ENABLE_GRID_STARS) return;

  const onReady = (fn) => (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', fn, { once: true })
    : fn();

  const qs  = (s, r=document) => r.querySelector(s);
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));

  function okendoRender() {
    // Single shot — no retries. Earlier versions retried at 100/400/1200/3000ms
    // to "cover lazy assets", but those retries fired AFTER Okendo had already
    // populated the widgets via its own auto-discovery on script-load, and the
    // re-init was clearing real review data after ~1–2s. (Symptom reported by
    // Ara 2026-05-27: "displays for 1-2 seconds then goes away".)
    //
    // Modern Okendo (`window.okeWidgetApi.initWidget(el)`, ~v0.94.x) is async
    // and idempotent — it skips elements with `data-oke-rendered`. We only need
    // to nudge UNRENDERED holders once: if Okendo's auto-discovery already
    // handled them, this call is a no-op; if it didn't, our call kicks them off.
    try {
      const api = window.okeWidgetApi;
      if (api && typeof api.initWidget === 'function') {
        document.querySelectorAll('.em-grid-stars:not([data-oke-rendered])')
          .forEach((el) => { try { api.initWidget(el); } catch(e) {} });
        return;
      }
      // Legacy API fallback for older Okendo installs (kept as a safety net).
      if (window.okeReviewsWidget?.refresh) window.okeReviewsWidget.refresh();
      if (window.okeWidget?.renderWidget) window.okeWidget.renderWidget();
      if (window.okeWidget?.renderAll) window.okeWidget.renderAll();
      window.dispatchEvent(new CustomEvent('oke:refresh'));
    } catch(e) {}
  }

  function makeHolder(pid) {
    const el = document.createElement('div');
    el.className = 'em-grid-stars';
    el.setAttribute('data-oke-star-rating', '');
    el.setAttribute('data-oke-star-rating-view', 'simple'); // safe hint for compact stars
    el.setAttribute('data-oke-reviews-product-id', `shopify-${pid}`);
    // inline safety so you see space even if CSS hasn’t loaded
    el.style.minHeight = '18px';
    el.style.lineHeight = '1';
    return el;
  }

  function injectIntoCard(card) {
    if (!card || card.querySelector('.em-grid-stars')) return;

    const pid   = card.getAttribute('data-product-id');
    const meta  = qs('.grid-product__meta', card);
    const title = qs('.grid-product__title', meta);
    const price = qs('.grid-product__price', meta);
    if (!pid || !meta) return;

    const holder = makeHolder(pid);

    // Preferred: right under title; fallback: before price; last: end of meta
    if (title && title.parentNode === meta) {
      title.insertAdjacentElement('afterend', holder);
    } else if (price && price.parentNode === meta) {
      meta.insertBefore(holder, price);
    } else {
      meta.appendChild(holder);
    }
  }

  function injectAll(root=document) {
    // Only call okendoRender() if we actually injected NEW holders. The previous
    // version called okendoRender unconditionally, which combined with the
    // MutationObserver below caused re-renders of already-populated widgets
    // every time Okendo itself added DOM nodes (its own rendering triggered
    // our MO, which re-triggered render, which raced with the in-flight init).
    let injected = false;
    qsa('.grid-product', root).forEach((card) => {
      if (card.querySelector('.em-grid-stars')) return; // already has holder
      injectIntoCard(card);
      if (card.querySelector('.em-grid-stars')) injected = true;
    });
    if (injected) okendoRender();
  }

  onReady(() => {
    injectAll();

    // Re-run when filters/pagination/sections redraw the grid
    [
      'shopify:section:load','shopify:section:select','shopify:section:deselect','shopify:section:unload',
      'collection:filter:updated','ajaxFilter:rendered','page:loaded','dom:changed'
    ].forEach(evt => document.addEventListener(evt, () => injectAll()));

    // MutationObserver fallback — observe document.body, NOT
    // .collection-grid__wrapper. When Impulse's filter UI applies a filter via
    // AJAX, it replaces the entire wrapper element (verified 2026-05-27 by
    // sample: same selector, different node identity). An observer attached to
    // the wrapper itself goes stale on first filter use; observing body
    // survives. Selectively fire only when a .grid-product node is added
    // (avoids running injectAll on unrelated body mutations).
    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.type !== 'childList') continue;
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.matches?.('.grid-product') || node.querySelector?.('.grid-product')) {
            injectAll(document);
            return;
          }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();

/* ==========================================================================
 * CUSTOM: Video Tutorials lightbox (/pages/tutorials)
 * ==========================================================================
 * The tutorials page body carries legacy `a.fancybox` links pointing at
 * YouTube /embed/ URLs. The old theme's fancybox player is gone in
 * Impulse 9.x, so a plain click navigated the whole page to a bare
 * youtube.com/embed URL. This delegates clicks on those links to a
 * minimal in-page lightbox (Esc / backdrop / button to close, focus
 * returned to the thumbnail on close).
 *
 * Styles: assets/custom.css under "Video Tutorials page".
 * Scoped by href — only intercepts links to https://www.youtube.com/embed/.
 *
 * Idle-chunked (2026-08-11, TBT): delegation arms via runIdle — a click in
 * the first ~2s degrades to the link's own navigation, which is the exact
 * pre-enhancement behavior.
 * ========================================================================== */
runIdle(function () {
  'use strict';

  var YT_EMBED = 'https://www.youtube.com/embed/';

  // Default player volume (0–100), applied ONCE when a video opens.
  // 50 = audible but not startling (25 is too quiet for voiceover); the
  // user's own adjustments are never overridden afterwards. Needs the
  // YouTube IFrame API — loaded lazily on first lightbox open; if the API
  // fails to load, the video simply plays at YouTube's own default.
  var DEFAULT_YT_VOLUME = 50;
  var ytApiPromise = null;

  function ensureYTApi() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (ytApiPromise) return ytApiPromise;
    ytApiPromise = new Promise(function (resolve) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') { try { prev(); } catch (_) {} }
        resolve();
      };
      var s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      s.async = true;
      s.onerror = function () { resolve(); };
      document.head.appendChild(s);
    });
    return ytApiPromise;
  }

  function openLightbox(embedUrl, triggerEl, orientation) {
    var overlay = document.createElement('div');
    overlay.className = 'em-video-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Video player');

    var frame = document.createElement('div');
    // Portrait frame (9:16) for YouTube Shorts — flagged by the renderer
    // via data-video-orientation (snippets/product-videos.liquid). The
    // default 16:9 frame letterboxes vertical video otherwise.
    frame.className = 'em-video-lightbox__frame' +
      (orientation === 'portrait' ? ' em-video-lightbox__frame--portrait' : '');

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'em-video-lightbox__close';
    closeBtn.setAttribute('aria-label', 'Close video');
    closeBtn.textContent = '×';

    var iframe = document.createElement('iframe');
    // Set src via property (not innerHTML) — page-authored hrefs never
    // get string-interpolated into markup.
    iframe.src = embedUrl + (embedUrl.indexOf('?') > -1 ? '&' : '?') +
      'autoplay=1&enablejsapi=1&origin=' + encodeURIComponent(location.origin);
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = 'Tutorial video';

    frame.appendChild(closeBtn);
    frame.appendChild(iframe);
    overlay.appendChild(frame);

    function close() {
      overlay.remove();
      document.removeEventListener('keydown', onKey);
      if (triggerEl && typeof triggerEl.focus === 'function') triggerEl.focus();
    }
    function onKey(ev) {
      if (ev.key === 'Escape') close();
    }

    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay || ev.target === closeBtn) close();
    });
    document.addEventListener('keydown', onKey);

    document.body.appendChild(overlay);
    closeBtn.focus();

    // Set the starting volume once the player is ready (best-effort).
    ensureYTApi().then(function () {
      if (!(window.YT && window.YT.Player)) return;
      try {
        new YT.Player(iframe, {
          events: {
            onReady: function (ev) {
              try { ev.target.setVolume(DEFAULT_YT_VOLUME); } catch (_) {}
            }
          }
        });
      } catch (_) {}
    });
  }

  // a.fancybox = legacy tutorials-page markup; a.em-video-link = our own
  // renderers (snippets/product-videos.liquid PDP thumbnails).
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a.fancybox, a.em-video-link') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.indexOf(YT_EMBED) !== 0) return;
    e.preventDefault();
    openLightbox(href, link, link.getAttribute('data-video-orientation'));
  });
}, 2500);

/* ==========================================================================
 * Desktop nav: dead-hash header guard (2026-08-11)
 * "Shop by …" parent items are being set to url "#" in Navigation admin so
 * the MOBILE drawer renders them as whole-row accordion buttons (Impulse's
 * built-in special-case — the fix for parents navigating instead of
 * expanding). The DESKTOP mega menu has no such special-case and renders
 * them as <a href="#">: clicking would jump the page to the top. Guard:
 * swallow clicks on hash-only links inside the desktop nav. Hover still
 * opens the mega menu; the "Shop All …" child carries the real link.
 * Not idle-chunked — it must guard the very first click.
 * ========================================================================== */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('.site-nav a[href="#"], .site-nav__dropdown-link[href="#"]') : null;
    if (link) e.preventDefault();
  });
})();

/* ==========================================================================
 * Micro Reassurance tiles: whole-tile click (2026-08-04)
 * The text-with-icons section's blocks can't carry links natively; each
 * tile's richtext holds a real <a> (added via template JSON). This
 * progressive enhancement lets a click anywhere on a tile follow that
 * link — no hardcoded URLs, it promotes whatever anchor the tile contains,
 * so editor changes keep working. Keyboard/AT users use the real anchor.
 * Idle-chunked (2026-08-11): pre-idle clicks fall back to the tile's real
 * inner anchor — the pre-enhancement behavior.
 * ========================================================================== */
runIdle(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var tile = e.target && e.target.closest ? e.target.closest('.text-with-icons__block') : null;
    if (!tile) return;
    if (e.target.closest('a')) return; // real link clicked — default behavior
    var link = tile.querySelector('a[href]');
    if (link) link.click();
  });
}, 2500);

/* ==========================================================================
 * A11y enhancer: accessible names for icon-only controls (2026-08-05)
 * From the PageSpeed desktop audit. Vanilla Impulse ships three icon-only
 * buttons with no accessible name (photo zoom, thumbnail prev/next), and
 * the text-columns "4 Steps" image links have no text (the image is
 * decorative; the labeled button below is the real CTA). Rule-7-safe DOM
 * patch: label the buttons, and take the duplicate image links out of the
 * a11y tree (standard pattern for adjacent duplicate links).
 * Idle-chunked (2026-08-11): aria patching a few seconds late is invisible
 * to AT users (screen readers read attributes at focus time, not load time);
 * the OT label poll now also starts at idle instead of at parse.
 * ========================================================================== */
runIdle(function () {
  'use strict';
  function enhance() {
    document.querySelectorAll('button.product__photo-zoom:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Zoom image');
    });
    document.querySelectorAll('button.product__thumb-arrow--prev:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Previous image');
    });
    document.querySelectorAll('button.product__thumb-arrow--next:not([aria-label])').forEach(function (b) {
      b.setAttribute('aria-label', 'Next image');
    });
    // Announcement bar sits outside header/main landmarks in vanilla markup
    // (axe "region" rule, PDP audit 2026-08-10) — promote it to one.
    var ann = document.getElementById('AnnouncementSlider');
    if (ann && !ann.getAttribute('role')) {
      ann.setAttribute('role', 'region');
      ann.setAttribute('aria-label', 'Announcements');
    }
    // 4 Steps image links: no text content -> remove from tab order + a11y
    // tree; the adjacent labeled button links to the same destination.
    // Same pattern for homepage feature-row image links (2026-08-05, from
    // the homepage audit): each quiz band wraps an empty-alt image in a
    // bare <a> duplicating the adjacent "Find My Match" button.
    document.querySelectorAll('.text-column__grid a, .feature-row a').forEach(function (a) {
      if (a.getAttribute('aria-hidden')) return;
      if ((a.textContent || '').trim()) return;
      if (a.querySelector('img') && !a.classList.contains('btn')) {
        a.setAttribute('aria-hidden', 'true');
        a.setAttribute('tabindex', '-1');
      }
    });
  }
  // OneTrust banner (injected late): the cookie-policy link's stock
  // aria-label ("More information about your privacy...") doesn't contain
  // its visible text "Cookie Policy" — WCAG 2.5.3 label-in-name (axe
  // label-content-name-mismatch, homepage audit 2026-08-05). OT admin has
  // no per-link aria field for this one, so sync it here: keep the
  // new-tab hint, lead with the visible text. Poll until the banner shows
  // (or give up after ~30s — returning visitors have no banner).
  var otTries = 0;
  var otTimer = setInterval(function () {
    var link = document.querySelector('#onetrust-banner-sdk .ot-cookie-policy-link');
    if (link) {
      var visible = (link.textContent || '').trim();
      var label = link.getAttribute('aria-label') || '';
      if (visible && label.indexOf(visible) === -1) {
        link.setAttribute('aria-label', visible + ', opens in a new tab');
      }
      clearInterval(otTimer);
    } else if (++otTries > 30) { clearInterval(otTimer); }
  }, 1000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }
}, 3000);
